import { useMutation, useQueryClient } from "@tanstack/react-query";
import { facilityApi } from "@bw/shared/api";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * Cancel a pending booking invitation (host only).
 * DELETE /facilities/{facilityId}/bookings/{bookingId}/invitations/{invitationId} → 204/void.
 *
 * On success the invitations query is INVALIDATED so it re-reads the server's
 * truth — the cancelled row leaves the list on the next refetch. Never an
 * optimistic local removal: the server owns the source of truth.
 */
export function useCancelBookingInvitation(
  facilityId: string | undefined,
  bookingId: string | undefined,
) {
  const queryClient = useQueryClient();
  return useMutation<void, unknown, string>({
    mutationFn: (invitationId: string) =>
      facilityApi.cancelBookingInvitation(
        facilityId as string,
        bookingId as string,
        invitationId,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.booking.invitations(
          facilityId ?? "",
          bookingId ?? "",
        ),
      });
    },
  });
}
